import { Divider } from '@components/core-ui/Divider';
import JobReportsIcon from '@components/icons/JobReports.svg';
import UsersIcon from '@components/icons/Users.svg';
import DashboardIcon from '@components/icons/Dashboard.svg';
import Folder from '@components/icons/FolderIcon.svg';
import GlobeIcon from '@components/icons/GlobeIcon.svg';
import TeamsIcon from '@components/icons/Teams.svg';
import { checkAssignedRepositories } from '@helpers/checkAssignedRepositories';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { SidebarLink } from '../SidebarLink';
import { WorkspacesListWrapper } from './components/WorkspaceListWrapper';

export const Menu = () => {
  const { me, workspace, organization } = useAuthContext();
  if (!organization) {
    return <></>;
  }

  // const workspaceViewReports = (workspace?.Teams ?? []).find((team) => team.viewReports);
  // const shouldShowReports = !!workspaceViewReports;
  const shouldShowReports = !!organization?.permissions?.viewReports;
  const shouldShowUsers = !!organization?.permissions?.manageMembers;
  const canManageWorkspaces = organization?.permissions?.manageWorkspaces;
  const shouldShowRepositories =
    !!organization?.permissions?.viewRepositories || checkAssignedRepositories(me, organization?.id || '').length > 0;

  return (
    <>
      <SidebarLink
        to={routes.dashboard.make(organization?.slug ?? '')}
        text="Dashboard"
        Icon={DashboardIcon}
        iconOffset={3}
        activeRoutes={[routes.dashboard.make(organization?.slug ?? '')]}
      />

      {shouldShowUsers ? (
        <SidebarLink
          to={routes.organizationMembers.make(organization?.slug ?? '')}
          text="Members"
          Icon={UsersIcon}
          iconOffset={3}
          activeRoutes={[
            routes.organizationMembers.make(organization?.slug ?? ''),
            routes.invitations.make(organization?.slug ?? ''),
            routes.organizationMemberReports.make(organization?.slug ?? ''),
          ]}
        />
      ) : null}

      {shouldShowUsers ? (
        <SidebarLink
          to={routes.organizationTeams.make(organization?.slug ?? '')}
          text="Teams"
          Icon={TeamsIcon}
          iconOffset={0}
          activeRoutes={[routes.organizationTeams.make(organization?.slug ?? '')]}
        />
      ) : null}

      {canManageWorkspaces ? (
        <SidebarLink
          to={routes.allJobs.make(organization?.slug ?? '')}
          text="All Jobs"
          Icon={GlobeIcon}
          iconOffset={0}
          activeRoutes={[routes.allJobs.make(organization?.slug ?? '')]}
        />
      ) : null}

      <Divider />

      {workspace ? <span className="text-xs text-foreground-muted font-medium block pl-2">Workspace</span> : null}

      {workspace ? <WorkspacesListWrapper /> : null}

      {workspace?.id ? (
        <>
          <SidebarLink
            to={routes.jobsList.make(organization?.slug ?? '', workspace?.slug ?? '')}
            text="Job List"
            Icon={JobReportsIcon}
            iconOffset={4}
            activeRoutes={[routes.jobsList.make(organization?.slug ?? '', workspace?.slug ?? '')]}
          />

          {shouldShowReports ? (
            <SidebarLink
              to={routes.jobsReport.make(organization?.slug ?? '', workspace?.slug ?? '')}
              text="Job Reports"
              Icon={JobReportsIcon}
              iconOffset={4}
              activeRoutes={[routes.jobsReport.make(organization?.slug ?? '', workspace?.slug ?? '')]}
            />
          ) : null}
        </>
      ) : null}

      {shouldShowRepositories ? (
        <SidebarLink
          to={routes.repositoriesList.make(organization?.slug ?? '')}
          text="Cases"
          Icon={Folder}
          iconOffset={1}
          activeRoutes={[routes.repositoriesList.make(organization?.slug ?? '')]}
        />
      ) : null}
    </>
  );
};
